import imageCompression from 'browser-image-compression';

export const compressImage = async (image: File, maxSize: number) => {
    try{
      const options = {
        maxSizeMb: maxSize,
        maxWidthOrHeight: undefined,
      }
      return await imageCompression(image, options);
    } catch(e){
      console.log(e);
    }
}